import $ from "jquery";
import { u_ } from "@pressmedia/webappbase";

/**
 * ajaxリクエスト送信
 * @param {String} method: called method name
 * @param {Object} ajaxSetting: request setting
 * @param {Function} cb: callback function (@arg1: err, @arg2: responce)
 * @return {Promise}
 */
function sendRequest(method, ajaxSetting, cb) {
	const df = $.Deferred();
	const def = {
		url: this.ACTION_URL,
		type: "GET",
		dataType: "json",
		timeout: this.config.ajaxTimeoutTime
	};
	
	if( u_.isObject(ajaxSetting) ) {
		ajaxSetting = Object.assign(def, ajaxSetting);
	} else {
		ajaxSetting = def;
	}
	
	u_.isFunction(cb) || (cb = function() {});
	
	if(!ajaxSetting.url) {
		const err = {
			code: NaN,
			messages: ["'url' is not defined."],
			method: method
		};
		
		return $.when( cb(err) ).always( df.reject.bind(df, err) );
	}
	
	$.ajax(ajaxSetting).then((res, textStatus, xhr) => {
		// success
		!res && (res = {});
		return $.when( cb(null, res, xhr, textStatus) ).then(
			df.resolve.bind(df, res, xhr, textStatus),
			df.reject.bind(df, true, xhr, textStatus)
		);
	}, (xhr, textStatus, errorThrown) => {
		// error
		const args = [method, xhr, textStatus, errorThrown];
		
		let err = this.ajaxErrorCallback.apply(this, args) || xhr.responseText;
		let res;
		if(err) {
			res = err.response || null;
		} else {
			err = true;
			res = null;
		}
		return $.when( cb(err, res, xhr, textStatus) )
		.always( df.reject.bind(df, err, xhr, textStatus) );
	});
	
	return df.promise();
}

export default sendRequest;
